import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { Button } from '../../../../../shard'
import { Size, Color } from '../../../../../../const'

function PasswordResetComplate() {
  const history = useHistory()

  return (
    <Wrapper>
      <TitleBlock>パスワード再設定完了</TitleBlock>
      <Message>パスワードの再設定が完了いたしました。</Message>
      <ButtonWrapper>
        <Button
          type={'submit'}
          primary
          onClick={() => {
            history.push('/login')
          }}
        >
          ログイン画面へ
        </Button>
      </ButtonWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 30px 20px;
`

const TitleBlock = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.HEADLINE.SMALL};
  padding: 40px 0px 20px 0px;
  border-bottom: 1px solid #ccc;
`

const Message = styled.div`
  padding: 10px 0;
  color: ${Color.FONT.ANNOTATION};
  padding-top: 30px;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 100px;
`

PasswordResetComplate.propTypes = {
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  dirty: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
}

export default PasswordResetComplate
